export default {
  manualApi: {
    getRoleFiles: 'api/manual/getRoleFiles',
    deleteFiles: 'api/manual/deleteFiles',
    getFile: 'api/manual/getFile',
    changeFile: 'api/manual/changeFile',
    addFile: 'api/manual/addFile',
    changeStatus: '/api/manual/changeStatus',
    getUserFiles: '/api/manual/getUserFiles'
  }
}